import { Flex, Text, Image } from "@fluentui/react-northstar";
import AccessDeniedIcon from "../../assets/img/accessDenied.png";
import React from "react";

const AccessDenied = () => {
    return (
        <React.Fragment>
            <Flex column gap="gap.medium" vAlign='center' hAlign="center" fill styles={{ height: "100Vh" }}>
                <Image src={AccessDeniedIcon} height="200px" width="200px" />
                <Text content="Drishti.EngageX is currently under maintenance." size="largest" color="brand" weight='bold' align="center" />
                <Text content="We are in the process of enabling EngageX for you. It will be back online shortly.
Thank you for your patience!" weight='semibold' size='large' align="center" />
            </Flex>
        </React.Fragment>
    );
};

export default AccessDenied;